<template>
  <div>
    <b-modal
      ref="modalProductTracking"
      size="lg"
      dialog-class="!max-w-[550px]"
      body-class="!p-[32px]"
      static
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      hide-header
      centered
    >
      <b-button
        variant="ghost"
        class="absolute top-[16px] right-[16px] !p-[16px] [&.btn-danger]:!bg-[#E31A1A] !flex items-center justify-center gap-[8px]"
        @click="hideModal"
      >
        <span class="k-close-circle text-[26px]" />
      </b-button>
      <h3 class="text-[#333333] text-[21px] text-center font-[500] mb-[24px]">
        Tracking Paket
      </h3>

      <div class="flex items-center justify-start gap-[16px] rounded-[12px] border-[1px] border-[#E2E2E2] p-[12px] mb-[12px]">
        <TrackingInfoCard
          title="Nomor Resi"
          :value="awb"
        />
        <TrackingInfoCard
          title="Ekspedisi"
          :value="logisticName"
        />
      </div>

      <div
        v-if="isLoading"
        class="flex items-center justify-center gap-[8px] my-[16px]"
      >
        <b-spinner
          small
          variant="primary"
        />
        <p class="text-[#333333] text-[14px] mb-0">
          Mohun tunggu sebentar...
        </p>
      </div>

      <div
        v-if="isError && !isLoading"
        class="my-[24px] flex flex-col items-center justify-center gap-[8px]"
      >
        <img
          src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
          alt="error"
          class="w-[80px] mx-auto"
        >
        <p class="text-[#333333] text-[14px] text-center mb-0">
          Terjadi kesalahan saat mengambil data tracking paket.
        </p>
        <b-button
          variant="primary"
          class="!flex items-center justify-center gap-[8px]"
          size="sm"
          :disabled="isLoading"
          @click="fetchHistory({
            order_id: orderId,
            marketplace: marketplace,
            awb: awb,
          })"
        >
          Coba Lagi
        </b-button>
      </div>

      <div
        v-if="!isLoading && !isError && history.length === 0"
        class="my-[24px] flex flex-col items-center justify-center gap-[8px]"
      >
        <img
          src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
          alt="error"
          class="w-[80px] mx-auto"
        >
        <p class="text-[#333333] text-[14px] text-center mb-0">
          Belum ada data tracking paket.
        </p>
      </div>

      <div v-if="!isLoading && !isError && history.length > 0">
        <div
          v-for="(item, index) in history"
          :key="item.date"
          class="relative flex items-center gap-[8px] justify-start before:content-[''] before:block before:w-[1px] before:h-[100%] before:border-l-[1px] before:border-[#F95031] before:absolute before:left-[12px] before:top-[50%] before:z-0 first:before:border-dashed last:before:hidden"
        >
          <span
            class="z-10 k-Checklist text-[20px] font-semibold size-[25px] flex items-center justify-center rounded-full border-[1.5px] border-[#F95031]"
            :class="index === 0 ? 'bg-white text-[#F95031]' : 'bg-[#F95031] text-white'"
          />
          <div class="p-[8px] pl-[16px]">
            <p class="text-[#333333] text-[14px] mb-[4px] font-semibold">
              {{ formatDate(item.UpdatedAt) }}
            </p>
            <p class="text-[#626262] text-[14px] mb-0 font-normal">
              {{ item.description }}
            </p>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { FULL_DATE_WITH_TIME } from '@/libs/formatDate'
import TrackingInfoCard from './TrackingInfoCard.vue'

export default {
  name: 'ModalPacketTracking',
  components: {
    TrackingInfoCard,
  },
  data() {
    return {
      logisticName: '-',
      orderId: '',
      marketplace: '',
      awb: '-',
      history: [],
      isLoading: false,
      isError: false,
    }
  },
  methods: {
    /**
     * Used by the parent component to show the modal
     * @param {Object} params - The parameters for showing the modal
     * @param {string} params.logistic_name - The logistic name
     * @param {string} params.order_id - The order ID
     * @param {string} params.marketplace - The marketplace code
     * @param {string} params.awb - The AWB number
     */
    showModal({
      logistic_name = '-',
      order_id = '',
      marketplace = '',
      awb = '',
    } = {}) {
      this.logisticName = logistic_name
      this.orderId = order_id
      this.marketplace = marketplace
      this.awb = awb
      this.history = []
      this.fetchHistory({
        order_id,
        marketplace,
        awb,
      })
      this.$refs.modalProductTracking.show()
    },
    /**
     * Used by the parent component to hide the modal
     */
    hideModal() {
      this.$refs.modalProductTracking.hide()
    },
    /**
     * Fetch the history of the package
     * @param {Object} params - The parameters for fetching the history
     */
    async fetchHistory({
      order_id = '',
      marketplace = '',
      awb = '',
    }) {
      try {
        this.isLoading = true
        const response = await this.$http_new.get('/komship/api/v1/marketplace-logistics/tracking-info', {
          params: {
            order_id,
            marketplace,
            awb,
          },
        })

        const { data } = response.data
        this.history = Array.isArray(data?.details) ? data.details : []
        this.isError = false
      } catch (error) {
        this.isError = true
      } finally {
        this.isLoading = false
      }
    },
    formatDate(date) {
      return FULL_DATE_WITH_TIME(date)
    },
  },
}
</script>
